import { useMemo } from 'react';

/* ================================================= Exported Functions ================================================= */
// ========================================== Loading
export const useIsLoadings = isLoadingsInArray => {
  const isLoading = useMemo(() => isLoadingsInArray.reduce((isLoading, currentIsLoading) => isLoading || currentIsLoading, false), [
    isLoadingsInArray
  ]);

  return { isLoading };
};
